import React from 'react';
import styled from '@emotion/styled';
import { getTextColor } from '../../../../../style';
import { handlePaymentVysionEvent } from '../../../../../utils/vysion/payment';
import { VYSION_ACTIONS } from '../../../../../utils/vysion';
import { PaymentClickVysionEventsEnum } from '../../../../../utils/vysion/payment/click';
import { CustomStyledProps } from 'style/style';
import breakpoints from 'theme/material/breakpoints';

const CreditThresholdContainer = styled('div')({
  position: 'relative',
  paddingBottom: 50,
});
const RangeStepSlider = styled('div')({
  position: 'absolute',
  top: 0,
  zIndex: 4,
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'space-between',
});

const RangeStepSliderTick = styled('div')(
  {
    background: '#D9D9D9',
    borderRadius: '50%',
    display: 'inline-flex',
    justifyContent: 'center',
    width: '13px',
    height: '13px',
    position: 'relative',
    cursor: 'pointer',
  },
  ({ selected }: CustomStyledProps) => selected && { background: '#2B8FD7 !important' }
);

const RangeStepSliderTickText = styled('span')(
  () => ({
    paddingTop: '1.6rem',
    ...getTextColor().DARK,
    fontWeight: 400,
    fontSize: 14,
  }),
  ({ selected }: CustomStyledProps) => selected && { fontWeight: 700, color: '#2B8FD7 !important' }
);

const RangeStepSliderInput = styled('div')({
  background: '#D9D9D9',
  width: 'calc(100% - 1px)',
  height: 6,
  borderRadius: 2,
  border: 0,
  margin: 0,
  padding: 0,
  position: 'absolute',
  top: '0.3rem',
  zIndex: 3,
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  [breakpoints.down('md')]: {
    top: '0.3rem',
  },
});

interface PaymentSettingsProps {
  threshold: any;
  setThreshold: any;
}

const CreditThreshold = ({ threshold, setThreshold }: PaymentSettingsProps): any => {
  const handleThresholdChange = threshold => {
    setThreshold(threshold);

    handlePaymentVysionEvent({
      action: VYSION_ACTIONS.CLICK,
      event: PaymentClickVysionEventsEnum.CLICK_ACCOUNT_MENU_PAYMENT_SETTINGS_CREDIT_THRESHOLD,
      newEventName: `accountMenu-paymentSettings-creditThreshold-${threshold}`,
      extraInfo: `${threshold}`,
    });
  };

  return (
    <CreditThresholdContainer>
      <RangeStepSliderInput
        // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
        type={'range'}
        min={1}
        max={100}
        step={2}
      />
      <RangeStepSlider>
        <RangeStepSliderTick onClick={() => handleThresholdChange(10)} selected={threshold === 10}>
          <RangeStepSliderTickText selected={threshold === 10}>10</RangeStepSliderTickText>
        </RangeStepSliderTick>
        <RangeStepSliderTick onClick={() => handleThresholdChange(15)} selected={threshold === 15}>
          <RangeStepSliderTickText selected={threshold === 15}>15</RangeStepSliderTickText>
        </RangeStepSliderTick>
        <RangeStepSliderTick onClick={() => handleThresholdChange(25)} selected={threshold === 25}>
          <RangeStepSliderTickText selected={threshold === 25}>25</RangeStepSliderTickText>
        </RangeStepSliderTick>
        <RangeStepSliderTick onClick={() => handleThresholdChange(50)} selected={threshold === 50}>
          <RangeStepSliderTickText selected={threshold === 50}>50</RangeStepSliderTickText>
        </RangeStepSliderTick>
      </RangeStepSlider>
    </CreditThresholdContainer>
  );
};

export default CreditThreshold;
